// eslint-disable-next-line no-redeclare
import { Container, Tabs } from '@mantine/core';
import { useEffect } from 'react';
import { IconBrandGoogle, IconCalendarEvent, IconExternalLink } from '@tabler/icons';
import { RoutingS } from '../../../Service/RoutingS';
import { ThemeText } from '../../../Atoms/ThemeText';
import { SubscriptionCalendar } from './SubscriptionCalendar/SubscriptionCalendar';
import ExternalSubscriptions from './ExternalSubscriptions/ExternalSubscriptions';
import GoogleCalendarsPane from './google/GoogleCalendarsPane';

const CalendarConfig = () => {
  useEffect(() => {
    RoutingS.changeTitle('Kalender-Sync');
  }, []);

  return (
    <Container p={0}>
      <ThemeText size="lg" weight="bolder">
        Kalender synchronisieren
      </ThemeText>
      <ThemeText my="md">
        Behalte Deine Termine in bookitup und in Deinem Kalender im Blick. Richte ein, wie bookitup Termine mit Deinen
        Kalendern austauscht. So bleiben Buchungen, Vermittlungen und Verfügbarkeiten an einem Ort gepflegt. Wähle unten
        die passende Verbindung: Kalender-Abo, externe Kalender oder direkte Google-Synchronisierung.
      </ThemeText>
      <Tabs
        keepMounted={false}
        mt="lg"
        defaultValue="subscription-calendar"
        styles={{
          tab: {
            '&[data-active]': {
              fontWeight: 'bolder',
            },
          },
        }}
      >
        <Tabs.List>
          <Tabs.Tab icon={<IconCalendarEvent size="0.8rem" />} value="subscription-calendar">
            Kalender-Abo
          </Tabs.Tab>
          <Tabs.Tab icon={<IconExternalLink size="0.8rem" />} value="external-subscriptions">
            Externe Kalender
          </Tabs.Tab>
          <Tabs.Tab icon={<IconBrandGoogle size="0.8rem" />} value="google-calendars">
            Google-Kalender
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="subscription-calendar" pt="xl">
          <SubscriptionCalendar />
        </Tabs.Panel>
        <Tabs.Panel value="external-subscriptions" pt="xl">
          <ExternalSubscriptions />
        </Tabs.Panel>
        <Tabs.Panel value="google-calendars" pt="xl">
          <GoogleCalendarsPane />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};

export default CalendarConfig;
